<template>
  <Paginate
    v-model="currentPage"
    :page-count="pageCount"
    :page-range="pageRange"
    :margin-pages="marginPages"
    :click-handler="clickCallback"
    :prev-text="prevText()"
    :next-text="nextText()"
    :container-class="'v1-cardDestinationPagination'"
    :page-class="'v1-cardDestinationPagination__item'"
    :page-link-class="'v1-cardDestinationPagination__link'"
    :prev-class="'v1-cardDestinationPagination__item -prev'"
    :prev-link-class="'v1-cardDestinationPagination__link -prev'"
    :next-class="'v1-cardDestinationPagination__item -next'"
    :next-link-class="'v1-cardDestinationPagination__link -next'"
    :break-view-class="'-ellipsis'"
    :break-view-link-class="''"
    :active-class="'-active'"
    :disabled-class="'-disabled'"
    :first-last-button="false"
  >
  </Paginate>
</template>

<script>
import Paginate from 'vuejs-paginate';
import UAParser from 'ua-parser-js';

const parser = new UAParser();
const isIE = parser.getBrowser().name === 'IE';

export default {
  components: {
    Paginate,
  },
  props: {
    // `currentPage`の初期値
    page: {
      require: false,
      type: Number,
      default: 1,
    },
    // 総ページ数
    pageCount: {
      require: true,
      type: Number,
      default: 1,
    },
    pageRange: {
      require: false,
      type: Number,
      default: 3,
    },
    marginPages: {
      require: false,
      type: Number,
      default: 1,
    },
  },
  created() {
    window.addEventListener('load', () => {
      this.addCurrent(this);
    });
  },
  computed: {
    currentPage() {
      return Number(this.page);
    },
  },
  methods: {
    // 絞り込み時に`currentPage`をリセットする
    resetCurrentPages() {
      this.currentPage = 1;
    },
    // `.-active`を目印に`aria-current`を付与する
    addCurrent() {
      if (!isIE) {
        const list = this.$el.querySelectorAll('.v1-cardDestinationPagination__item');
        Array.from(list).forEach(item => {
          const isActive = !!item.classList.contains('-active');
          item.removeAttribute('aria-current');
          if (isActive) {
            item.setAttribute('aria-current', 'page');
          }
        });
      }
    },
    // ページネーションクリック時に、ページ数を親コンポーネントに渡す
    clickCallback(data) {
      this.$emit('updatePageNumber', data);
      setTimeout(() => {
        this.addCurrent(this);
      }, 0);
    },
    // 「前へ」ボタンのHTML
    prevText() {
      return `<svg class="v1-cardDestinationPagination__previous" role="img" focusable="false"><use xlink:href="/japan-travel-planner/common/svg/sprite.svg#chevron-left"></use></svg>`;
    },
    // 「次へ」ボタンのHTML
    nextText() {
      return `<svg class="v1-cardDestinationPagination__next" role="img" focusable="false"><use xlink:href="/japan-travel-planner/common/svg/sprite.svg#chevron-right"></use></svg>`;
    },
  },
};
</script>

<style lang="scss">
.Pagination {
  display: inline-flex;
  align-items: center;
  flex-grow: 1;
  flex-wrap: wrap;
  justify-content: center;
  padding-left: 0;
  border: 1px solid #aaa;
  list-style-type: none;
}

.Pagination_Item {
  &:nth-of-type(n + 2) {
    border-left: 1px solid #aaa;
  }
}

.Pagination_Link {
  display: block;
  padding: 1em;

  .-active & {
    background-color: #aaa;
  }
}
</style>
